import { memo, type MouseEvent, useCallback, useMemo } from "react";

import { CollectionAdjacentCollectionButtonView } from "@react/sections/Collection/CollectionFilterNavigation/CollectionAdjacentCollectionButton.view";
import { getCollectionPath } from "@react/utilities/collection";

type Props = {
  adjacentCollection: {
    handle: string;
    id: string;
    onlineStoreUrl: string | null | undefined;
    title: string;
  };
  handleAdjacentCollectionChange: (collection: {
    handle: string;
    id: string;
    onlineStoreUrl: string | null | undefined;
    title: string;
  }) => void;
  isActive: boolean;
};

const isModifiedClick = (event: MouseEvent<HTMLAnchorElement>) =>
  event.button !== 0 ||
  event.metaKey ||
  event.ctrlKey ||
  event.shiftKey ||
  event.altKey;

const CollectionAdjacentCollectionButtonBase = ({
  adjacentCollection,
  handleAdjacentCollectionChange,
  isActive,
}: Props) => {
  const href = useMemo(
    () => getCollectionPath(adjacentCollection.handle),
    [adjacentCollection.handle]
  );

  const handleAdjacentCollectionButtonClick = useCallback(
    (event: MouseEvent<HTMLAnchorElement>) => {
      // New-tab and new-window clicks follow the link normally
      if (isModifiedClick(event)) {
        return;
      }

      event.preventDefault();

      if (!isActive) {
        handleAdjacentCollectionChange(adjacentCollection);
      }
    },
    [adjacentCollection, handleAdjacentCollectionChange, isActive]
  );

  return (
    <CollectionAdjacentCollectionButtonView
      adjacentCollection={adjacentCollection}
      handleAdjacentCollectionButtonClick={handleAdjacentCollectionButtonClick}
      href={href}
      isActive={isActive}
    />
  );
};

export const CollectionAdjacentCollectionButton = memo(
  CollectionAdjacentCollectionButtonBase
);
